
import request from '@/axios/index.js'
const uri = '/user/lawTxt/authGetCode';
// 获取验证码
export function AccountAuthorizeCodeAPI(data) {
    return request.axios({
        url: uri,
        data:data,
        type:"post"
    })
}
// 电子签章授权确定
export function AccountConfirmCodeAPI(data) {
    return request.axios({
        url: '/user/lawTxt/confirmCode',
        data:data,
        type:"post",
        loading:true
    })
}




// WEBPACK FOOTER //
// ./src/api/eleSign.js